













































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import EndpointOpt from './tool-bar-endpoint-select-opt.vue';
@Component({components: {EndpointOpt}})
export default class ToolBarEndpointSelect extends Vue {
  @Action('SEARCH_ENDPOINTS') public SEARCH_ENDPOINTS: any;
  @Prop() public data!: any;
  @Prop() public current!: any;
  @Prop() public title!: string;
  @Prop() public icon!: string;
  public search: string = '';
  public visible: boolean = false;
  public handleSearch() {
    this.SEARCH_ENDPOINTS(this.search);
  }
  public handleOpen() {
    this.visible = true;
  }
  public handleSelect(i: any) {
    this.$emit('onChoose', i);
    this.visible = false;
  }
}
